export const IMAGES = {
  hero: "/hero.jpg",
  laundry: "https://images.pexels.com/photos/8774639/pexels-photo-8774639.jpeg?auto=compress&cs=tinysrgb&w=1600",
  chef: "https://images.pexels.com/photos/5490976/pexels-photo-5490976.jpeg?auto=compress&cs=tinysrgb&w=1600",
  warewash: "/skyllerom.jpg",
  smallware: "https://images.pexels.com/photos/4252142/pexels-photo-4252142.jpeg?auto=compress&cs=tinysrgb&w=1600",
  institution: "https://images.pexels.com/photos/2544830/pexels-photo-2544830.jpeg?auto=compress&cs=tinysrgb&w=1600",
  serviceVan: "/servicebil.jpg",
};

export const CONTACT = {
  phone: "93 46 25 50",
  phoneRaw: "93462550",
  sales: "post@trondelagstorkjokken.no",
  service: "service@trondelagstorkjokken.no",
  customerPortal: "https://trondelag.storkjokkensenteret.no/customer",
  address: "Jæktskippergata 8, 7725 Steinkjer",
};

export const SERVICE_POINTS = ["Steinkjer", "Stjørdal", "Verdal", "Trondheim"];

export const SERVICES = [
  {
    num: "01",
    title: "Storkjøkken",
    image: IMAGES.chef,
    text: "Komplett prosjektering og leveranse av utstyr til restauranter, hoteller, kantiner og profesjonelle kjøkken. Fra kombidamper til hette- og tunnelmaskiner fra Electrolux — alt fra ett sted.",
    points: ["Kombidampere & ovner", "Kjøl & frys", "Oppvask & benker", "Hette- & tunnelmaskiner", "Prosjektering"],
  },
  {
    num: "02",
    title: "Vaskeri",
    image: IMAGES.laundry,
    text: "Robuste vaskeriløsninger for institusjoner, hoteller og industri. Vaskemaskiner, tørketromler og rulleutstyr dimensjonert for høy kapasitet og lang levetid.",
    points: ["Industrivaskemaskiner", "Tørketromler", "Rulle & stryk", "Doseringsanlegg"],
  },
  {
    num: "03",
    title: "Skyllerom",
    image: IMAGES.warewash,
    text: "Dedikerte skylleroms- og oppvaskløsninger som holder tempo når det står på — blant annet utstyr fra Steelco. Rustfrie benker og gjennomtenkt logistikk for full hygiene.",
    points: ["Steelco-løsninger", "Oppvaskmaskiner", "Rustfrie benker", "Avfallshåndtering"],
  },
  {
    num: "04",
    title: "Institusjon",
    image: IMAGES.institution,
    text: "Skreddersydde løsninger for sykehjem, sykehus og offentlige bygg — der driftssikkerhet, hygiene og enkelt vedlikehold er avgjørende hver eneste dag.",
    points: ["Sykehjem & sykehus", "Sentralkjøkken", "Hygienesoner", "Serviceavtaler"],
  },
  {
    num: "05",
    title: "Småutstyr",
    image: IMAGES.smallware,
    text: "Fra slikkepott til bestikk — vi fører et komplett utvalg av småutstyr til det profesjonelle kjøkkenet. Kniver, redskaper, servise, glass og kopper i en kvalitet som tåler daglig, hard bruk.",
    points: ["Kniver & redskaper", "Bestikk & servise", "Glass & kopper", "Gryter & panner", "Forbruksvarer"],
  },
];

export const SUPPLIERS = [
  { name: "Electrolux Professional", tag: "Sertifisert Partner", url: "https://www.electroluxprofessional.com/no/" },
  { name: "Colia", tag: "Kjøkkenutstyr", url: "https://www.colia.no/" },
  { name: "Hoshizaki", tag: "Kjøl & is", url: "https://hoshizaki-europe.com/no/" },
  { name: "Rustfri Bergh", tag: "Rustfritt", url: "https://www.rustfriebergh.no/" },
  { name: "Steelco", tag: "Skyllerom", url: "https://www.steelcobelimed.com/" },
  { name: "Rupro", tag: "Innredning", url: "https://rupro.no/" },
  { name: "Stayhot", tag: "Varmholding", url: "https://en.stayhot.se/" },
  { name: "Bravilor", tag: "Kaffe", url: "https://www.bravilor.com/no" },
  { name: "TEFCold", tag: "Kjøl & frys", url: "https://www.tefcold.com/" },
  { name: "Solenis", tag: "Kjemi", url: "https://www.solenis.com/nb-no/" },
  { name: "Alminor", tag: "Lagring", url: "https://www.alminor.com/" },
  { name: "Horeka", tag: "Småutstyr", url: "https://www.horeka.no/" },
];

export const NAV = [
  { label: "Tjenester", href: "#tjenester" },
  { label: "Leverandører", href: "#leverandorer" },
  { label: "Service", href: "#service" },
  { label: "Om oss", href: "#om-oss" },
  { label: "Kontakt", href: "#kontakt" },
];
